import { css } from "@emotion/core";
import PropTypes from "prop-types";
import React from "react";

import Spacer from "./Spacer";
import Wrapper from "./Wrapper";

const Section = ({ children, bottomSpacer = 6, ...props }) => (
  <section {...props}>
    <Wrapper>
      <Spacer rem={6}></Spacer>
      {children}
      {bottomSpacer > 0 && <Spacer rem={bottomSpacer}></Spacer>}
    </Wrapper>
  </section>
);

Section.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Section;

export const BackgroundSection = (props) => (
  <Section
    css={css`
      position: relative;
      z-index: 1;
      background: linear-gradient(180deg, var(--gradient-start) 0%, var(--gradient-end) 100%);
    `}
    {...props}
  />
);
